export default {
  id: 59,
  title: 'Target #59 - Earth',
  url: 'https://cssbattle.dev/play/59',
  colors: ['#191919', '#4F77FF'],
  solution:
    '<a a><a b><a c><a d><style>body,a[b],a[c]{background:#191919}a{position:fixed}a[a]{top:75;left:125;width:150;height:150;background:#4F77FF;border-radius:50%}a[b],a[c]{top:70;left:195;width:10;height:160}a[c]{transform:rotate(90deg);box-shadow:-40px 0 #191919,40px 0 #191919}a[d]{top:87.5;left:137.5;width:105;height:105;border:10px solid #191919;border-radius:0 105px;transform:rotate(45deg)}</style>',
}
